import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["JQLEditor", "onSyntaxHelp"];
import React, { useCallback } from 'react';
import { useAutocompleteProvider } from '@atlassianlabs/jql-editor-autocomplete-rest';
import { router } from '@forge/bridge';
import { di } from 'react-magnetic-di';
import { getInitialData } from '../utils/get-initial-data';
import { getSuggestions } from '../utils/get-suggestions';
export var JQLEditorForgeUI = function JQLEditorForgeUI(_ref) {
  var JQLEditor = _ref.JQLEditor,
    onSyntaxHelp = _ref.onSyntaxHelp,
    rest = _objectWithoutProperties(_ref, _excluded);
  var analyticsSource = 'forge';
  var autocompleteProvider = useAutocompleteProvider(analyticsSource, getInitialData, getSuggestions);
  var onForgeSyntaxHelp = useCallback(function (e) {
    var handled = onSyntaxHelp && onSyntaxHelp(e);

    // Prevent default behaviour when the event is handled on the consumer side.
    if (!handled) {
      var href = e.currentTarget.getAttribute('href');

      // Forge apps are sandboxed in an iframe that doesn't allow popups. We need to use the Forge router to follow
      // the navigation https://developer.atlassian.com/platform/forge/custom-ui-bridge/router/#navigate
      if (href) {
        router.open(href);
      }
    }

    // Event is always explicitly handled for Forge consumers.
    return true;
  }, [onSyntaxHelp]);
  return /*#__PURE__*/React.createElement(JQLEditor, _extends({}, rest, {
    analyticsSource: analyticsSource,
    autocompleteProvider: autocompleteProvider,
    onSyntaxHelp: onForgeSyntaxHelp
  }));
};